var map = {
	"./Fibbotool.svg": 113,
	"./Mediamodifier-Design.svg": 211,
	"./add.svg": 114,
	"./area.svg": 212,
	"./bar.svg": 213,
	"./bar1.svg": 115,
	"./baseline.svg": 214,
	"./bursh.svg": 116,
	"./calender.svg": 117,
	"./candle.svg": 70,
	"./clock.svg": 118,
	"./dataWindow.svg": 119,
	"./downArrow.svg": 215,
	"./hekeneshi.svg": 216,
	"./hotlist.svg": 120,
	"./idea.svg": 121,
	"./kagi.svg": 217,
	"./line.svg": 111,
	"./lineTool.svg": 122,
	"./nextButton.svg": 123,
	"./pattern.svg": 124,
	"./playButton.svg": 125,
	"./point figure.svg": 218,
	"./positionTool.svg": 126,
	"./renko.svg": 219,
	"./reset.svg": 220,
	"./text.svg": 127
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 210;